/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultConversationItemList } from '../../models/api-response-paged-result-conversation-item-list';
import { PagedRequestConversationSearchReq } from '../../models/paged-request-conversation-search-req';

export interface ListConversationsOfCompanyNumber$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  refPhoneCompany: string;
      body: PagedRequestConversationSearchReq
}

export function listConversationsOfCompanyNumber(http: HttpClient, rootUrl: string, params: ListConversationsOfCompanyNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultConversationItemList>> {
  const rb = new RequestBuilder(rootUrl, listConversationsOfCompanyNumber.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('refPhoneCompany', params.refPhoneCompany, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultConversationItemList>;
    })
  );
}

listConversationsOfCompanyNumber.PATH = '/v1/api/ui/conversation/list-of/{refPhoneCompany}';
